export enum ECostSummaryType {
  TECHNICAL_REPORT = 'technicalReport',
  EXTRA = 'extra',
  UNIFIED = 'unified',
}
